var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickwwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/tick-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tick-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 1.89453C4.8675 1.89453 1.5 5.26203 1.5 9.39453C1.5 13.527 4.8675 16.8945 9 16.8945C13.1325 16.8945 16.5 13.527 16.5 9.39453C16.5 5.26203 13.1325 1.89453 9 1.89453ZM12.585 7.66953L8.3325 11.922C8.2275 12.027 8.085 12.087 7.935 12.087C7.785 12.087 7.6425 12.027 7.5375 11.922L5.415 9.79953C5.1975 9.58203 5.1975 9.22203 5.415 9.00453C5.6325 8.78703 5.9925 8.78703 6.21 9.00453L7.935 10.7295L11.79 6.87453C12.0075 6.65703 12.3675 6.65703 12.585 6.87453C12.8025 7.09203 12.8025 7.44453 12.585 7.66953Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickwwhite);
export default __webpack_public_path__ + "static/media/tickwwhite.19fd96bba56f04228c9e502c6d14fa47.svg";
export { ForwardRef as ReactComponent };